import { CONFIG_UPDATE, ConfigActions, ConfigState } from './types';

const initialState: ConfigState = {
  analytics: {
    configuration: { writeKey: '' },
    driver: '',
  },
  features: {},
  langFallBack: {},
  langWhiteList: [],
  lluHome: '',
  lslApi: '',
  lv: '',
  partners: {
    api: {},
    commercialapi: {},
    fhir: {},
    inbound: {},
    insulet: {},
    redox: {},
  },
  privacyPolicy: {
    default: '',
  },
  quickShareCode: null,
  regionalMap: {},
  regions: {},
  supportedProducts: {
    libreview: {},
    librelinkup: {},
  },
  termsOfUse: {
    default: '',
  },
};

export const configReducer = (state = initialState, action: ConfigActions): ConfigState => {
  switch (action.type) {
    case CONFIG_UPDATE:
      return {
        ...state,
        ...action.config,
      };

    default:
      return state;
  }
};
